import { render, staticRenderFns } from "./svg-img.vue?vue&type=template&id=42272f3e"
import script from "./svg-img.vue?vue&type=script&lang=js"
export * from "./svg-img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports